// libraries
import React from 'react'

// dependencies
import { Dialog2 as Dialog } from '@st-operations/uikit/src/v1/index.js'
import SelectBox from './SelectBox.jsx'
import { Collapsible, CheckBox, CircularLoader } from '@st-operations/uikit/src/v2/index.js'

// style
import '../../css/components/CohortsQueryPane.styl'

// component
class SyntheticUsersQueryPane extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      attributes_option: [],
      data: [],
      show_selected_attributes: false,
      loading: false,
      ATTRIBUTES: {
        attribute: { enabled: true, val: null },
      },
      CLUSTERING: {
        country: { enabled: true, val: null },
        state: { enabled: true, val: null },
        age: { enabled: true, val: null },
        content_language: { enabled: true, val: null },
        device_type: { enabled: true, val: null },
        gender: { enabled: true, val: null },
        os: { enabled: true, val: null },
      },
      FILTERS: {
        age: { enabled: true, val: null },
        content_language: { enabled: true, val: null },
        country: { enabled: true, val: null },
        state: { enabled: true, val: null },
        device_type: { enabled: true, val: null },
        gender: { enabled: false, val: null },
        os: { enabled: false, val: null },
      },
    }
  }

  componentWillMount = () => {
    // TODO, create synthetic user schema and replace it
    window._api.get(`/event-feeds/schema`, (error, schema) => {
      if (error) {
        toast.error(error.message)
      }

      if (schema) {
        this.setState({
          schema,
        })
      }
    })
  }

  handleOnAttributesChange = (attribute, option, name, val, key) => {
    this.setState((prevState) => ({
      [key]: {
        ...prevState[key], //copy unchanged attributes
        [attribute]: {
          ...prevState[key][attribute], //copy unchanged fields
          val, //set value
        },
      },
    }))
    setTimeout(() => this.onSubmitQuery(), 200)
  }

  //Dialog
  onOpenUpdateAttributes = (group) => {
    let attributes_option = null
    if (group === 'ATTRIBUTES') {
      attributes_option = this.state.ATTRIBUTES
    }
    if (group === 'FILTERS') {
      attributes_option = this.state.FILTERS
    }
    if (group === 'CLUSTERING') {
      attributes_option = this.state.CLUSTERING
    }
    const { show_selected_attributes } = this.state
    this.setState({
      show_selected_attributes: !show_selected_attributes,
      attributes_option,
      editGroup: group,
    })
  }

  onCloseModal = () => {
    const { show_selected_attributes } = this.state
    this.setState({ show_selected_attributes: !show_selected_attributes })
  }

  handleClickCheckbox = (name) => {
    let { editGroup } = this.state
    if (editGroup === 'ATTRIBUTES') {
      this.setState((prevState) => ({
        ATTRIBUTES: {
          ...prevState.ATTRIBUTES, //copy unchanged attributes
          [name]: {
            ...prevState.ATTRIBUTES[name], //copy unchanged fields
            enabled: !prevState.ATTRIBUTES[name].enabled, //set value
          },
        },
      }))
    }
    if (editGroup === 'FILTERS') {
      this.setState((prevState) => ({
        FILTERS: {
          ...prevState.FILTERS, //copy unchanged attributes
          [name]: {
            ...prevState.FILTERS[name], //copy unchanged fields
            enabled: !prevState.FILTERS[name].enabled, //set value
          },
        },
      }))
    }
    if (editGroup === 'CLUSTERING') {
      this.setState((prevState) => ({
        CLUSTERING: {
          ...prevState.CLUSTERING, //copy unchanged attributes
          [name]: {
            ...prevState.CLUSTERING[name], //copy unchanged fields
            enabled: !prevState.CLUSTERING[name].enabled, //set value
          },
        },
      }))
    }
    this.setState((prevState) => ({
      attributes_option: {
        ...prevState.attributes_option, //copy unchanged attributes
        [name]: {
          ...prevState.attributes_option[name], //copy unchanged fields
          enabled: !prevState.attributes_option[name].enabled, //set value
        },
      },
    }))
  }

  onSubmitQuery = () => {
    let { ATTRIBUTES, FILTERS, CLUSTERING } = this.state
    let { onChangeTableData, onChangeSelectedAttributes } = this.props

    // assemble query
    let query = {
      attributes: {},
      filters: {},
      clustering: {},
    }

    this.assembleQuery(ATTRIBUTES, query.attributes)
    this.assembleQuery(FILTERS, query.filters)
    this.assembleQuery(CLUSTERING, query.clustering)
    if (Object.keys(query.attributes).length < 1 && Object.keys(query.clustering).length < 1) {
      return
    }

    this.setState({ loading: true })
    query.index = 'synthetic_users'
    query.size = 10
    window._api.post('/data-explorer/synthetic-users', query, (error, res) => {
      this.setState({ loading: false })
      if (error) {
        toast.error(error.message)
      } else {
        onChangeTableData(res)
        onChangeSelectedAttributes(query)
      }
    })
  }

  assembleQuery = (group, query) => {
    return Object.keys(group).forEach((name) => {
      if (group[name].enabled && group[name].val && group[name].val.length > 0) {
        query[name] = group[name].val
      }
    })
  }

  render() {
    let {
      ATTRIBUTES,
      CLUSTERING,
      FILTERS,
      attributes_option,
      loading,
      schema,
      show_selected_attributes,
    } = this.state
    return (
      <div className="attributes-group">
        <If condition={loading}>
          <CircularLoader />
        </If>

        {/* clustering section */}
        <Collapsible title={'Clustering'} subtitle={''} openByDefault={false}>
          <SelectBox
            title={'country'}
            isMulti={true}
            isSearchable={true}
            options={schema?.filtering?.country?.enum}
            onChange={(option, name, val) =>
              this.handleOnAttributesChange('country', option, name, val, 'CLUSTERING')
            }
            show={CLUSTERING.country.enabled}
          />
          <SelectBox
            title={'state'}
            isMulti={true}
            isSearchable={true}
            options={schema?.filtering?.state?.enum}
            onChange={(option, name, val) =>
              this.handleOnAttributesChange('state', option, name, val, 'CLUSTERING')
            }
            show={CLUSTERING.state.enabled}
          />
          <SelectBox
            title={'age'}
            isFilter={true}
            isMulti={true}
            isSearchable={true}
            options={[
              'age_18_24',
              'age_25_34',
              'age_55_64',
              'age_35_44',
              'age_45_54',
              'age_65_plus',
            ]}
            onChange={(option, name, val) =>
              this.handleOnAttributesChange('age', option, name, val, 'CLUSTERING')
            }
            show={CLUSTERING.age.enabled}
          />
          <SelectBox
            title={'content_language'}
            isMulti={true}
            isSearchable={true}
            options={['en', 'es', 'pt', 'fr', 'it', 'ru', 'ja', 'tr', 'zh', 'ro']}
            onChange={(option, name, val) =>
              this.handleOnAttributesChange('content_language', option, name, val, 'CLUSTERING')
            }
            show={CLUSTERING.content_language.enabled}
          />
          <SelectBox
            title={'device_type'}
            isMulti={true}
            isSearchable={true}
            options={[
              'Personal computer',
              'Smartphone',
              'Tablet',
              'Game console',
              'Smart TV',
              'Other',
            ]}
            onChange={(option, name, val) =>
              this.handleOnAttributesChange('device_type', option, name, val, 'CLUSTERING')
            }
            show={CLUSTERING.device_type.enabled}
          />
          <SelectBox
            title={'OS'}
            isMulti={true}
            isSearchable={true}
            options={['Windows', 'Android', 'OS X', 'iOS', 'Chrome OS', 'Linux']}
            onChange={(option, name, val) =>
              this.handleOnAttributesChange('os', option, name, val, 'CLUSTERING')
            }
            show={CLUSTERING.os.enabled}
          />
          <SelectBox
            title={'gender'}
            isMulti={true}
            isSearchable={true}
            options={['male', 'female']}
            onChange={(option, name, val) =>
              this.handleOnAttributesChange('gender', option, name, val, 'CLUSTERING')
            }
            show={CLUSTERING.gender.enabled}
          />
          <a className="addBtn" onClick={() => this.onOpenUpdateAttributes('CLUSTERING')}>
            + Add
          </a>
        </Collapsible>

        {/* select attributes section */}
        <Collapsible title={'Attributes'} subtitle={''} openByDefault={false}>
          <SelectBox
            title={'attribute'}
            isMulti={false}
            isSearchable={true}
            options={[
              'age',
              'brands',
              'domains',
              'gender',
              'health_conditions',
              'homebiz_type',
              'keywords',
              'movies',
              'music_groups',
              'natural_events',
              'os',
              'persons',
              'tv_shows',
              'urls',
              'vehicles',
            ]}
            onChange={(option, name, val) =>
              this.handleOnAttributesChange('attribute', option, name, val, 'ATTRIBUTES')
            }
            show={ATTRIBUTES.attribute.enabled}
          />
          <a className="addBtn" onClick={() => this.onOpenUpdateAttributes('ATTRIBUTES')}>
            + Add
          </a>
        </Collapsible>

        {/* filters section */}
        <Collapsible title={'Filters'} subtitle={''} openByDefault={false}>
          <SelectBox
            title={'age'}
            isFilter={true}
            isMulti={true}
            isSearchable={true}
            options={[
              'age_18_24',
              'age_25_34',
              'age_55_64',
              'age_35_44',
              'age_45_54',
              'age_65_plus',
            ]}
            onChange={(option, name, val) =>
              this.handleOnAttributesChange('age', option, name, val, 'FILTERS')
            }
            show={FILTERS.age.enabled}
          />
          <SelectBox
            title={'content_language'}
            isMulti={true}
            isSearchable={true}
            options={['en', 'es', 'pt', 'fr', 'it', 'ru', 'ja', 'tr', 'zh', 'ro']}
            onChange={(option, name, val) =>
              this.handleOnAttributesChange('content_language', option, name, val, 'FILTERS')
            }
            show={FILTERS.content_language.enabled}
          />
          <SelectBox
            title={'country'}
            isMulti={true}
            isSearchable={true}
            options={schema?.filtering?.country?.enum}
            onChange={(option, name, val) =>
              this.handleOnAttributesChange('country', option, name, val, 'FILTERS')
            }
            show={FILTERS.country.enabled}
          />
          <SelectBox
            title={'state'}
            isMulti={true}
            isSearchable={true}
            options={schema?.filtering?.state?.enum}
            onChange={(option, name, val) =>
              this.handleOnAttributesChange('state', option, name, val, 'FILTERS')
            }
            show={FILTERS.state.enabled}
          />
          <SelectBox
            title={'device_type'}
            isMulti={true}
            isSearchable={true}
            options={[
              'Personal computer',
              'Smartphone',
              'Tablet',
              'Game console',
              'Smart TV',
              'Other',
            ]}
            onChange={(option, name, val) =>
              this.handleOnAttributesChange('device_type', option, name, val, 'FILTERS')
            }
            show={FILTERS.device_type.enabled}
          />
          <SelectBox
            title={'OS'}
            isMulti={true}
            isSearchable={true}
            options={['Windows', 'Android', 'OS X', 'iOS', 'Chrome OS', 'Linux']}
            onChange={(option, name, val) =>
              this.handleOnAttributesChange('os', option, name, val, 'FILTERS')
            }
            show={FILTERS.os.enabled}
          />
          <SelectBox
            title={'gender'}
            isMulti={false}
            isSearchable={true}
            options={['male', 'female']}
            onChange={(option, name, val) =>
              this.handleOnAttributesChange('gender', option, name, val, 'FILTERS')
            }
            show={FILTERS.gender.enabled}
          />
          <a className="addBtn" onClick={() => this.onOpenUpdateAttributes('FILTERS')}>
            + Add
          </a>
        </Collapsible>

        <div style={{ height: 300 }} />
        <Dialog
          open={show_selected_attributes}
          onCancel={this.onCloseModal}
          title={'Add attributes'}
        >
          <For each="name" of={Object.keys(attributes_option)}>
            <div key={name} className="dialog-item">
              <CheckBox
                onChange={() => this.handleClickCheckbox(name)}
                name="extension"
                value={name}
                checked={attributes_option[name].enabled}
              />
              <span className="dialog-item-name">{name}</span>
            </div>
          </For>
        </Dialog>
      </div>
    )
  }
}

// export
export default SyntheticUsersQueryPane
